import Vue from 'vue'
import VueMoment from 'vue-moment'
import App from './App.vue'
import router from './router'
import store from './store'
import titleMixin from './titlemixin'
import VueAnalytics from 'vue-analytics'

//var VueResource = require('vue-resource');

Vue.config.productionTip = false
Vue.use(require('vue-moment'));
//Vue.use(VueResource);
Vue.mixin(titleMixin)

Vue.use(VueAnalytics, {
  id: 'UA-17670743-2'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
